export default __webpack_public_path__ + "static/Reinvestment_letter-c74f192fa400df7525258f8290aeb8b9.pdf";